// extracted by mini-css-extract-plugin
export var indeterminate = "_5p-5";
export var md = "_5p-4";
export var semantic = "_5p-6";
export var sm = "_5p-3";
export var text = "_5p-7";
export var toggleInput = "_5p-0";
export var toggleSwitch = "_5p-1";
export var xs = "_5p-2";